import Canceled from './Canceled';

export default Canceled;
